import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-default",
  "use": "icon-default-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-default\">\n<path d=\"M26.1,22.5h147.7c4.1,0,7.4,3.3,7.4,7.4v7.4c0,4.1-3.3,7.4-7.4,7.4H26.1c-4.1,0-7.4-3.3-7.4-7.4v-7.4\n\tC18.8,25.8,22.1,22.5,26.1,22.5z M26.1,88.9h96c4.1,0,7.4,3.3,7.4,7.4v7.4c0,4.1-3.3,7.4-7.4,7.4h-96c-4.1,0-7.4-3.3-7.4-7.4v-7.4\n\tC18.8,92.2,22.1,88.9,26.1,88.9z M26.1,155.4h147.7c4.1,0,7.4,3.3,7.4,7.4v7.4c0,4.1-3.3,7.4-7.4,7.4H26.1c-4.1,0-7.4-3.3-7.4-7.4\n\tv-7.4C18.8,158.7,22.1,155.4,26.1,155.4z M148,117.3V82.7c0-4.3,5.7-6.5,9-3.4l19,17.3c2.1,1.9,2.1,4.9,0,6.8l-19,17.3\n\tC153.7,123.8,148,121.6,148,117.3L148,117.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/default.svg
// module id = RzwZ
// module chunks = 166